import axios, { redirectToErrorPage } from './axios-config';
import { addTrackingHeader, buildApiEndpoint, getRequestBody, languageMap } from '../helper-fns/apiHelper';
import { IApiErrorResponse, ICheckDomainBody, IGetAvailRequest, ISaveOffer, ITollListResponse } from '../models';

const removeOfferSessionData = () => {
	sessionStorage.removeItem('memberOfferHash');
	sessionStorage.removeItem('offerHash');
};

// To be extended if we want to handle errors differently
const handleApiException = ({ response }: IApiErrorResponse, withRedirection = true) => {
	const {
		status: code,
		data: { errors },
	} = response;
	if (withRedirection) {
		removeOfferSessionData();
		redirectToErrorPage();
	}
	return { errors, code };
};

export const TollService = {
	getAvail: async ({ body, lang, withRedirection }: IGetAvailRequest): Promise<ITollListResponse> =>
		await axios
			.post(buildApiEndpoint(`/toll/getAvail`), getRequestBody({ body, lang }), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res, withRedirection)),
	getOfferInfo: async (body: { offerHash: string }) =>
		await axios
			.post(buildApiEndpoint(`/offer/getInfo`), getRequestBody({ body }), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
	saveOfferDocDetails: async (body: ISaveOffer) =>
		await axios
			.post(buildApiEndpoint(`/toll/saveOfferDocDetails`), getRequestBody({ body }), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
	getCountries: async (lang = 'de') =>
		await axios
			.get(buildApiEndpoint(`/toll/getCountries?language=${languageMap[lang]}`), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
	getFuelTypes: async () =>
		await axios
			.get(buildApiEndpoint('/toll/getFuelTypes'), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
	getTollClasses: async () =>
		await axios
			.get(buildApiEndpoint('/toll/getTollClasses'), addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
	checkDomain: async (body: ICheckDomainBody) =>
		await axios
			.post(buildApiEndpoint('/toll/checkDomain'), body, addTrackingHeader())
			.then(({ data, status }) => ({ ...data, code: status }))
			.catch((res: IApiErrorResponse) => handleApiException(res)),
};
